import { REHYDRATE } from 'redux-persist';
import update from 'immutability-helper';

import {
  ANY_FIELD_UPDATE,
  ANY_FIELD_REMOVE,
  NESTED_RECORD_ADD,
  NESTED_RECORD_REMOVE,
  updatedObject,
  removeNestedFields,
} from 'actions/formActions';
import { LOGOUT } from 'actions/loginStateActions';
import {
  COMPANY_PROFILE_UPDATE_START_REVISE,
  COMPANY_PROFILE_UPDATE_NO_REVISE,
  COMPANY_PROFILE_UPDATE_FETCH_BEGIN,
  COMPANY_PROFILE_UPDATE_FETCH_SUCCESS,
  COMPANY_PROFILE_UPDATE_FETCH_FAIL,
  COMPANY_PROFILE_UPDATE_BEGIN,
  COMPANY_PROFILE_UPDATE_SUCCESS,
  COMPANY_PROFILE_UPDATE_UPLOAD_SUCCESS,
  COMPANY_PROFILE_UPDATE_FAIL,
  COMPANY_PROFILE_DOCUMENT_UPLOAD_BEGIN,
  COMPANY_PROFILE_DOCUMENT_UPLOAD_SUCCESS,
  COMPANY_PROFILE_DOCUMENT_UPLOAD_FAIL,
  COMPANY_PROFILE_CERT_DELETE,
  PRIVACY_FIELD_UPDATE_PUT_BEGIN,
  PRIVACY_FIELD_UPDATE_PUT_SUCCESS,
  PRIVACY_FIELD_UPDATE_PUT_FAIL,
  MANAGER_SUPPLIER_PROFILE_FETCH_BEGIN,
  MANAGER_SUPPLIER_PROFILE_FETCH_SUCCESS,
  MANAGER_SUPPLIER_PROFILE_FETCH_FAIL,
  BUYER_PROFILE_FETCH_BEGIN,
  BUYER_PROFILE_FETCH_SUCCESS,
  BUYER_PROFILE_FETCH_FAIL,
  MANAGER_SUPPLIER_PROFILE_BEGIN,
  MANAGER_SUPPLIER_PROFILE_SUCCESS,
  MANAGER_SUPPLIER_PROFILE_UPLOAD_SUCCESS,
  MANAGER_SUPPLIER_PROFILE_FAIL,
  COMPANY_PROFILE_DELETE_PHOTOS_BEGIN,
  COMPANY_PROFILE_DELETE_PHOTOS_SUCCESS,
  COMPANY_PROFILE_DELETE_PHOTOS_FAIL,
  COMPANY_PROFILE_HANDLE_TAGS_BEGIN,
  COMPANY_PROFILE_HANDLE_TAGS_SUCCESS,
  COMPANY_PROFILE_HANDLE_TAGS_FAIL,
  MANAGER_SUPPLIER_DOCUMENT_UPDATE_BEGIN,
  MANAGER_SUPPLIER_DOCUMENT_UPDATE_SUCCESS,
  MANAGER_SUPPLIER_DOCUMENT_UPDATE_FAIL,
  COMPANY_PROFILE_STRENGTH_UPDATE_BEGIN,
  COMPANY_PROFILE_STRENGTH_UPDATE_SUCCESS,
  COMPANY_PROFILE_STRENGTH_UPDATE_FAIL,
} from './types';

import INITIAL_STATE from './state';
import { SUPPLIER_DOCUMENT_UPLOAD_SUCCESS } from '../types';

export default function companyProfileUpdateWorkspaceReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REHYDRATE:
      return INITIAL_STATE;

    case COMPANY_PROFILE_UPDATE_FETCH_BEGIN:
      return { data: {}, status: 'fetching' };

    case COMPANY_PROFILE_UPDATE_FETCH_SUCCESS: {
      return {
        data: {
          company: {
            ...action.data,
          },
          supplier: {
            ...INITIAL_STATE.data.supplier,
          },
        },
        status: 'viewing',
      };
    }

    case COMPANY_PROFILE_UPDATE_FETCH_FAIL:
      return { data: {}, status: 'failed', failReason: action.reason };

    case MANAGER_SUPPLIER_PROFILE_FETCH_BEGIN:
      return { data: {}, status: 'fetching' };

    case MANAGER_SUPPLIER_PROFILE_FETCH_SUCCESS: {
      const { company, ...supplier } = action.data;

      return {
        data: {
          company: {
            company_name: (company && company.company_name) || '',
            companyNameChi: (company && company.companyNameChi) || '',
            address: (company && company.address) || '',
            address2: (company && company.address2) || '',
            city: (company && company.city) || '',
            country: (company && company.country) || '',
            contactPerson: (company && company.contactPerson) || '',
            contactPersonPosition: (company && company.contactPersonPosition) || '',
            contactPersonPhone: (company && company.contactPersonPhone) || '',
            contactPersonEmail: (company && company.contactPersonEmail) || '',
            productLiabilityInsurance: (company && company.productLiabilityInsurance) || false,
            yearEstablished: (company && company.yearEstablished) || '',
            companyPermission: (company && company.companyPermission) || {},
            tradingStrength: (company && company.tradingStrength) || 0,
            factoryStrength: (company && company.factoryStrength) || 0,
            tags: (company && company.tags) || INITIAL_STATE.data.company.tags,
            productCategories:
              (company && company.productCategories) ||
              INITIAL_STATE.data.company.productCategories,
            companyCertifications: (company && company.companyCertifications) || [{}],
            insuranceCountries: (company && company.insuranceCountries) || [{}],
            productProduceds: (company && company.productProduceds) || [{}],
            ...company,
          },
          supplier: {
            name: supplier.name || '',
            email: supplier.email || '',
            salesEmail: supplier.salesEmail || '',
            qaEmail: supplier.qaEmail || '',
            address1: supplier.address1 || '',
            businessType: supplier.businessType || '',
            contactPerson: supplier.contactPerson || '',
            phoneNumber: supplier.phoneNumber || '',
            website: supplier.website || '',
            isBookmarked: supplier.isBookmarked || false,
            supplierCertifications: supplier.supplierCertifications || [{}],
            supplierRating: supplier.supplierRating || {},
            tags: supplier.tags || INITIAL_STATE.data.supplier.tags,
            productCategories:
              supplier.productCategories || INITIAL_STATE.data.supplier.productCategories,
            document: supplier.document,
            ...supplier,
          },
        },
        status: 'viewing',
      };
    }

    case MANAGER_SUPPLIER_PROFILE_FETCH_FAIL: {
      return { data: { view: {} }, status: 'failed', failReason: action.reason };
    }

    case BUYER_PROFILE_FETCH_BEGIN:
      return { data: {}, status: 'fetching' };

    case BUYER_PROFILE_FETCH_SUCCESS:
      return {
        data: {
          ...action.data,
          topMarkets: action.data.topMarkets || [],
          productCategories: action.data.productCategories || [{}],
          majorCustomers:
            action.data.majorCustomers !== 0
              ? action.data.majorCustomers
              : INITIAL_STATE.data.majorCustomers,
          companyCertifications:
            action.data.companyCertifications !== 0
              ? action.data.companyCertifications
              : INITIAL_STATE.data.companyCertifications,
          productLiabilityInsurance: action.data.productLiabilityInsurance ? 'yes' : 'no',
          yearEstablished: action.data.yearEstablished
            ? action.data.yearEstablished.toString()
            : null,
          deletedAuditCerts: [],
        },
        status: 'viewing',
      };

    case BUYER_PROFILE_FETCH_FAIL:
      return { data: {}, status: 'failed', failReason: action.reason };

    case NESTED_RECORD_ADD: {
      if (action.storeName !== 'companyProfileUpdateWorkspace') return state;

      return {
        ...state,
        data: {
          ...state.data,
          [action.fieldName]: [...state.data[action.fieldName], {}],
        },
      };
    }

    case NESTED_RECORD_REMOVE: {
      if (action.storeName !== 'companyProfileUpdateWorkspace') return state;

      return {
        ...state,
        data: {
          ...state.data,
          [action.fieldName]: state.data[action.fieldName].filter(
            (item, idx) => idx !== action.idx
          ),
        },
      };
    }

    case ANY_FIELD_UPDATE: {
      if (action.storeName !== 'companyProfileUpdateWorkspace') return state;

      return { ...state, data: updatedObject(state.data, action.accessPath, action.newVal) };
    }

    case COMPANY_PROFILE_UPDATE_BEGIN:
      return { ...state, status: 'submitting' };

    case COMPANY_PROFILE_UPDATE_SUCCESS:
      return { ...state, status: 'uploading' };

    case COMPANY_PROFILE_UPDATE_UPLOAD_SUCCESS:
      return { ...state, status: 'viewing' };

    case COMPANY_PROFILE_UPDATE_FAIL: {
      return { ...state, status: 'failed', failReason: action.reason };
    }

    case COMPANY_PROFILE_DOCUMENT_UPLOAD_BEGIN:
      return { ...state, status: 'submitting' };

    case COMPANY_PROFILE_DOCUMENT_UPLOAD_SUCCESS:
      return { ...state, status: 'uploading' };

    case COMPANY_PROFILE_DOCUMENT_UPLOAD_FAIL: {
      return { ...state, status: 'failed', failReason: action.reason };
    }

    case MANAGER_SUPPLIER_PROFILE_BEGIN:
      return { ...state, status: 'submitting' };

    case MANAGER_SUPPLIER_PROFILE_SUCCESS:
      return { ...state, status: 'uploading' };

    case MANAGER_SUPPLIER_PROFILE_UPLOAD_SUCCESS:
      return { ...state, status: 'viewing' };

    case MANAGER_SUPPLIER_PROFILE_FAIL:
      return { ...state, status: 'failed', failReason: action.reason };

    case PRIVACY_FIELD_UPDATE_PUT_BEGIN:
      return { ...state, status: 'submitting' };

    case PRIVACY_FIELD_UPDATE_PUT_SUCCESS:
      return { ...state, status: 'viewing' };

    case PRIVACY_FIELD_UPDATE_PUT_FAIL:
      return {
        ...state,
        status: 'failed',
        failReason: action.reason,
      };

    case COMPANY_PROFILE_DELETE_PHOTOS_BEGIN:
      return Object.assign({}, state, {
        status: 'submitting',
      });

    case COMPANY_PROFILE_DELETE_PHOTOS_SUCCESS:
      return Object.assign({}, state, {
        status: 'completed',
      });

    case COMPANY_PROFILE_DELETE_PHOTOS_FAIL:
      return update(state, {
        status: { $set: 'failed' },
        failReason: { $set: action.reason },
      });

    case COMPANY_PROFILE_HANDLE_TAGS_BEGIN:
      return update(state, { status: { $set: 'fetching' } });

    case COMPANY_PROFILE_HANDLE_TAGS_SUCCESS:
      return update(state, { status: { $set: 'success' } });

    case COMPANY_PROFILE_HANDLE_TAGS_FAIL:
      return update(state, {
        status: { $set: 'failed' },
        failReason: { $set: action.reason },
      });

    case ANY_FIELD_REMOVE: {
      if (action.storeName !== 'companyProfileUpdateWorkspace') return state;

      return {
        ...state,
        data: removeNestedFields(state.data, action.accessPath),
        isChanged: true,
      };
    }

    case COMPANY_PROFILE_UPDATE_START_REVISE:
      return { ...state, status: 'editing' };

    case COMPANY_PROFILE_UPDATE_NO_REVISE:
      return { ...state, status: 'viewing' };

    case COMPANY_PROFILE_CERT_DELETE:
      if (action.storeName !== 'companyProfileUpdateWorkspace') return state;

      return {
        ...state,
        data: {
          ...state.data,
          deletedAuditCerts: [...state.data.deletedAuditCerts, { id: action.id }],
        },
      };

    case MANAGER_SUPPLIER_DOCUMENT_UPDATE_BEGIN:
      return { ...state, status: 'fetching' };

    case MANAGER_SUPPLIER_DOCUMENT_UPDATE_SUCCESS: {
      const { data: item, method, params } = action;
      const stateList = state.data.supplier.document;
      let updatedList = [];

      if (method === 'PUT') {
        if (item && state && state.data && state.data.supplier && stateList && stateList.length) {
          stateList.forEach((doc) => {
            if (doc.id === item.id) {
              const updatedDoc = { ...doc, ...item };
              updatedList.push(updatedDoc);
            } else {
              updatedList.push(doc);
            }
          });
        }
      } else if (method === 'DELETE') {
        const { documentMapsId = 0 } = params;

        if (documentMapsId) {
          updatedList = stateList.filter((doc) => doc.id !== documentMapsId);
        }
      }

      return {
        ...state,
        data: {
          ...state.data,
          supplier: {
            ...state.data.supplier,
            document: updatedList.length ? updatedList : stateList,
          },
        },
        status: 'success',
      };
    }

    case MANAGER_SUPPLIER_DOCUMENT_UPDATE_FAIL:
      return { ...state, status: 'failed', failReason: action.reason };

    case COMPANY_PROFILE_STRENGTH_UPDATE_BEGIN:
      return { ...state, status: 'updating' };

    case COMPANY_PROFILE_STRENGTH_UPDATE_SUCCESS: {
      const { tradingStrength, factoryStrength } = action.data;

      return {
        ...state,
        data: {
          ...state.data,
          company: {
            ...state.data.company,
            tradingStrength,
            factoryStrength,
          },
        },
        status: 'success',
      };
    }

    case COMPANY_PROFILE_STRENGTH_UPDATE_FAIL:
      return { ...state, status: 'failed', failReason: action.reason };

    case LOGOUT:
      return { ...INITIAL_STATE, status: 'uninitialized' };

    case SUPPLIER_DOCUMENT_UPLOAD_SUCCESS:
      return {
        data: {
          ...state.data,
          supplier: {
            ...state.data.supplier,
            document: [...state.data.supplier.document, action.data],
          },
        },
        status: 'viewing',
      };

    default:
      return state;
  }
}
